import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, Observable, tap, throwError } from 'rxjs';

export function serviceTechnicalBreakInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const router = inject(Router);
  return next(req).pipe(
    tap(event => {
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 503) {
        router.navigate(['technical-break']);
        return EMPTY;
      }
      return throwError(() => error);
    }),
  );
}